"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSites = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_bar_1 = require("client/components/filter-bar");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const table_1 = require("client/components/material/table");
const table_row_1 = require("client/components/material/table/table-row");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const store_2 = require("client/modules/users/store");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
const store_3 = require("../../store");
require("./edit-sites.less");
const columns = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy"
    },
    {
        center: true,
        id: "city",
        numeric: false,
        label: "Location"
    },
    {
        center: true,
        id: "inventorysite.price",
        numeric: false,
        label: "Pharmacy Cost"
    },
    {
        center: true,
        id: "inventorysite.priceCash",
        numeric: false,
        label: "Cash Cost"
    },
    {
        center: true,
        id: "inventorysite.quantity",
        numeric: false,
        label: "Qty"
    }
];
let EditSites = class EditSites extends react_1.Component {
    constructor() {
        super(...arguments);
        this.inventorysites = [];
        this.numChecked = 0;
        this.indeterminate = false;
        this.checkedAll = false;
        this.checkedBoxes = {};
        this.checkedRowId = -1;
        this.editRowIndex = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "name";
        this.isCollapse = true;
        this.filterText = "";
        this.showConfirmationInventoryEditSiteSave = false;
        this.showConfirmationInventoryEditSiteRowSave = false;
        this.loadSites = throttle_debounce_1.debounce(200, () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy
            };
            // sitesListStore.loadSites(options);
            store_1.sitesListStore.loadSitesNoRelation(options);
        });
        this.renderInventorySite = (site) => {
            console.info("site----", site);
            return (React.createElement("div", { className: "main" },
                React.createElement("div", { className: "site-name" },
                    React.createElement("h3", null,
                        React.createElement("a", { href: "../../pharmacies/" + site.id }, site.displayName || site.name)),
                    React.createElement("h4", null,
                        site.city,
                        ", ",
                        site.state,
                        " | ",
                        site.phone)),
                React.createElement("div", { className: "inventorysite-info" },
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Pharmacy Cost", onChange: this.handleChangeString("price", site), type: "text", numType: "price", value: this.inventorysite && this.inventorysite.price
                                ? this.inventorysite.price
                                : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Cash Cost", onChange: this.handleChangeString("priceCash", site), type: "text", numType: "price", value: this.inventorysite && this.inventorysite.priceCash
                                ? this.inventorysite.priceCash
                                : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Quantity", onChange: this.handleChangeString("quantity", site), required: true, type: "number", numType: "integer", value: this.inventorysite && this.inventorysite.quantity
                                ? this.inventorysite.quantity
                                : 0 })),
                    React.createElement("div", { className: "inventorysite-info__buttons" },
                        React.createElement(button_1.MaterialButton, { className: "btnCancelRow", onClick: this.handleCancelRow }, "Cancel"),
                        React.createElement(button_1.MaterialButton, { onClick: () => {
                                console.info("save clicked");
                                this.showConfirmationInventoryEditSiteRowSave = true;
                            }, 
                            // onClick={this.handleSaveRow}
                            className: `button-status-${this.status}`, primary: true }, this.status === ui_1.FormStatus.Saved ? "Saved" : "Save")))));
        };
        this.renderListRowEditMode = (child, index) => (React.createElement("tr", { key: -1 },
            React.createElement("td", { colSpan: 6, className: "td-edit" }, ((this.checkedRowId === this.editRowIndex &&
                this.editRowIndex === index) ||
                (this.editRowIndex === index && !this.isCollapse)) && (React.createElement("div", { className: "edit-inventorysite" },
                React.createElement("div", { className: "list-component__row" }, this.renderInventorySite(child)))))));
        this.renderTable = () => (
        // <UiForm
        //   buttons={[
        //     <MaterialButton className="btnCancel" onClick={this.handleCancel}>
        //       Cancel
        //     </MaterialButton>,
        //     "Save"
        //   ]}
        //   loading={this.props.loading}
        //   isChanged={this.isChanged}
        //   status={this.status}
        //   saved="Saved"
        //   // onSubmit={() => this.showConfirmationInventoryEditSiteSave = true}
        //   onSubmit={this.handleSubmit}
        //   error={this.props.error}
        // >
        React.createElement("div", { className: "inventory__sites__list" }, store_1.sitesListStore.sites.value && (React.createElement(table_1.MaterialTable, { noMargin: true, checkbox: this.renderCheckAll(), columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_1.sitesListStore.sites.value, renderRow: this.renderTableRow })))
        // </UiForm>
        );
        this.renderTableRow = (row, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            const inventorysite = this.inventorysites &&
                this.inventorysites.find(inventorysite => !!inventorysite.site && inventorysite.site.id === row.id);
            const price = inventorysite && inventorysite.price ? inventorysite.price : "";
            const priceCash = inventorysite && inventorysite.priceCash ? inventorysite.priceCash : "";
            const quantity = inventorysite && inventorysite.quantity ? inventorysite.quantity : 0;
            const siteName = row.displayName || row.name;
            return [
                React.createElement(table_row_1.MaterialTableRow, { className: className, key: index, onClick: () => this.handleRowClick(row, index) },
                    React.createElement(Table_1.TableCell, null,
                        React.createElement(checkbox_1.MaterialCheckbox, { checked: this.checkedBoxes[row.id] || false, label: "", onAction: () => this.handleCheckRow(row) })),
                    React.createElement(Table_1.TableCell, null, capitalize_string_1.capitalizeString(siteName)),
                    React.createElement(Table_1.TableCell, null,
                        capitalize_string_1.capitalizeString(row.city),
                        ", ",
                        row.state),
                    React.createElement(Table_1.TableCell, null, price),
                    React.createElement(Table_1.TableCell, null, priceCash),
                    React.createElement(Table_1.TableCell, null, quantity))
                // this.renderListRowEditMode(row, index)
            ];
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadSites();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadSites();
        };
        this.updateInventorySites = () => {
            if (!this.inventorysite)
                return;
            const matched = this.inventorysites.find(inventorysite => !!inventorysite.site &&
                !!this.inventorysite &&
                !!this.inventorysite.site &&
                inventorysite.site.id === this.inventorysite.site.id);
            if (!matched) {
                this.inventorysites.push(ramda_1.merge(this.inventorysite, {}));
            }
            else {
                matched.quantity = this.inventorysite.quantity || 0;
                matched.price = this.inventorysite.price || 0;
                matched.priceCash = this.inventorysite.priceCash || 0;
            }
            this.updateNumChecked();
        };
        this.updateInventorySite = (site) => {
            if (this.inventorysites) {
                const matched = this.inventorysites.find(inventorysite => !!inventorysite.site && inventorysite.site.id === site.id);
                this.inventorysite = ramda_1.merge({}, matched);
                this.inventorysiteCache = ramda_1.merge({}, matched);
            }
        };
        this.handleChangeString = (fieldName, site) => (event, value) => {
            this.inventorysite = ramda_1.merge(this.inventorysite, {
                [fieldName]: value,
                site
            });
            if (parseInt(value, 10) > 0 || parseFloat(value) > 0) {
                this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                    [site.id]: true
                });
            }
            this.updateInventorySites();
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
        };
        this.isChanged = () => {
            const inventory = store_3.inventoryDetailStore.inventory.value;
            if (!inventory) {
                return false;
            }
            const comparator = (inventorySite1, inventorySite2) => {
                const result = ramda_1.difference(Object.entries(ramda_1.omit(["id", "site", "quantity"], inventorySite1)), Object.entries(ramda_1.omit(["id", "site", "quantity"], inventorySite2)));
                const result2 = ramda_1.difference(Object.entries(ramda_1.omit(["id", "site", "quantity"], inventorySite2)), Object.entries(ramda_1.omit(["id", "site", "quantity"], inventorySite1)));
                return (result.length === 0 &&
                    result2.length === 0 &&
                    String(inventorySite1.quantity) === String(inventorySite2.quantity));
            };
            const result = ramda_1.differenceWith(comparator, this.getInventorySitesToSubmit(), inventory.sites);
            const result2 = ramda_1.differenceWith(comparator, inventory.sites, this.getInventorySitesToSubmit());
            let isNewAdd = false;
            for (const key in this.checkedBoxes) {
                if (this.checkedBoxes.hasOwnProperty(key)) {
                    const siteId = this.checkedBoxes[key] === true ? Number(key) : -1;
                    const inventorysite = this.inventorysites.find(inventorysite => inventorysite.siteId === siteId);
                    if (!inventorysite) {
                        isNewAdd = true;
                        break;
                    }
                }
            }
            return result.length > 0 || result2.length > 0 || isNewAdd;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleCancelRow = () => {
            this.inventorysite = ramda_1.merge(this.inventorysiteCache, {});
            this.updateInventorySites();
            this.editRowIndex = -1;
        };
        this.handleSaveRow = () => {
            this.handleSubmit();
            this.editRowIndex = -1;
            this.showConfirmationInventoryEditSiteRowSave = false;
        };
        this.handleCheckRow = (child) => {
            this.isCollapse = false;
            this.checkedRowId = child.id;
            this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                [child.id]: !this.checkedBoxes[child.id]
            });
            this.updateNumChecked();
            // updatesite endpoint
            if (this.props.inventory) {
                this.props.onUpdateSite({
                    id: this.props.inventory.id,
                    siteId: child.id
                });
            }
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
        };
        this.updateNumChecked = () => {
            let numChecked = 0;
            for (const key in this.checkedBoxes) {
                if (this.checkedBoxes[key]) {
                    numChecked++;
                }
            }
            this.numChecked = numChecked;
            if (this.numChecked === 0) {
                this.checkedAll = false;
                this.indeterminate = false;
            }
            else if (store_1.sitesListStore.sites.value &&
                this.numChecked === store_1.sitesListStore.sites.value.length) {
                this.checkedAll = true;
                this.indeterminate = false;
            }
            else {
                this.indeterminate = true;
            }
        };
        // Active Formulary > Does not save update after select all  then deselect all C-046.182
        this.handleCheckAll = () => {
            const siteIds = [];
            store_1.sitesListStore.sites.value &&
                store_1.sitesListStore.sites.value.forEach(site => {
                    this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                        [site.id]: true
                    });
                    siteIds.push(site.id); // Collecting site IDs for the update
                });
            console.log("handleCheckAll: checking all", this.checkedAll);
            // Call onUpdateSite with the array of selected site IDs
            this.props.updateAllsite({
                id: this.props.inventory.id,
                siteIds: siteIds,
                // checkedSelection: "All",
                isCheckedAll: !this.checkedAll // Pass the current
            });
            this.checkedAll = !this.checkedAll;
            this.updateNumChecked();
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
        };
        this.handleRowClick = (child, index) => {
            this.updateInventorySites();
            if (this.editRowIndex === index) {
                this.isCollapse = !this.isCollapse;
            }
            else {
                this.isCollapse = false;
            }
            this.checkedRowId = -1;
            this.editRowIndex = index;
            this.currentRowIndex = index;
            this.updateInventorySite(child);
        };
        this.getInventorySitesToSubmit = () => {
            const inventorysitesToSubmit = [];
            this.inventorysites.map(inventorysite => {
                if (inventorysite.site &&
                    this.checkedBoxes[inventorysite.site.id] === true) {
                    const inventorysiteToSubmit = ramda_1.merge(inventorysite, {});
                    inventorysiteToSubmit.price = inventorysiteToSubmit.price
                        ? inventorysiteToSubmit.price
                        : 0;
                    inventorysiteToSubmit.priceCash = inventorysiteToSubmit.priceCash
                        ? inventorysiteToSubmit.priceCash
                        : 0;
                    inventorysitesToSubmit.push(inventorysiteToSubmit);
                }
            });
            return inventorysitesToSubmit;
        };
        this.handleSubmit = () => {
            if (!this.props.inventory)
                return;
            const multiSelections = [];
            for (const key in this.checkedBoxes) {
                if (this.checkedBoxes[key]) {
                    multiSelections.push(key);
                }
            }
            const inventorysitesToSubmit = this.getInventorySitesToSubmit();
            callable_1.callable(this.props.onSave)(ramda_1.merge({ id: this.props.inventory.id }, {
                sites: multiSelections
            }), inventorysitesToSubmit);
            this.showConfirmationInventoryEditSiteSave = false;
        };
    }
    componentWillMount() {
        // sitesListStore.loadSites();
        store_1.sitesListStore.loadSitesNoRelation();
        this.initializeInventorySite();
    }
    componentWillReceiveProps(props) {
        this.initializeInventorySite();
        this.status = props.status;
    }
    render() {
        return (React.createElement("div", { className: "inventory-edit-site" }, store_2.usersStore.permissions.ReadPharmacies ? (React.createElement(React.Fragment, null,
            this.renderFilter(),
            this.renderTable(),
            this.showConfirmationInventoryEditSiteSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the changes to inventory sites?`, onCancel: () => (this.showConfirmationInventoryEditSiteSave = false), onConfirm: this.handleSubmit, title: "Save confirmation" })),
            this.showConfirmationInventoryEditSiteRowSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the changes to this inventory site?`, onCancel: () => (this.showConfirmationInventoryEditSiteRowSave = false), onConfirm: this.handleSaveRow, title: "Save confirmation" })))) : (store_2.usersStore.showLock())));
    }
    renderCheckAll() {
        return (React.createElement(checkbox_1.MaterialCheckbox, { onAction: this.handleCheckAll, label: "", checked: this.checkedAll, indeterminate: this.indeterminate }));
    }
    renderFilter() {
        return (React.createElement("div", { className: "sites__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: this.onCallback, filterText: this.filterText })));
    }
    initializeInventorySite() {
        this.inventorysites = [];
        const inventory = store_3.inventoryDetailStore.inventory.value;
        if (!inventory)
            return;
        for (const inventorysite of inventory.sites) {
            if (inventorysite.price || inventorysite.priceCash) {
                inventorysite.price = inventorysite.price || 0;
                inventorysite.priceCash = inventorysite.priceCash || 0;
                this.inventorysites.push(ramda_1.merge(inventorysite, {
                    price: inventorysite.price.toFixed(2),
                    priceCash: inventorysite.priceCash.toFixed(2)
                }));
                // this.inventorysites.push(
                //   merge(inventorysite, {
                //     price: (inventorysite.price / 100).toFixed(2),
                //     priceCash: (inventorysite.priceCash / 100).toFixed(2),
                //   }),
                // );
            }
            else {
                this.inventorysites.push(ramda_1.merge(inventorysite, {}));
            }
        }
        this.checkedBoxes = {};
        this.inventorysites.map(inventorysite => {
            if (inventorysite.site) {
                this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                    [inventorysite.site.id]: true
                });
            }
        });
        this.updateNumChecked();
    }
};
__decorate([
    mobx_1.observable
], EditSites.prototype, "inventorysite", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "inventorysites", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "numChecked", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "indeterminate", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "checkedRowId", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "editRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "showConfirmationInventoryEditSiteSave", void 0);
__decorate([
    mobx_1.observable
], EditSites.prototype, "showConfirmationInventoryEditSiteRowSave", void 0);
EditSites = __decorate([
    mobx_react_1.observer
], EditSites);
exports.EditSites = EditSites;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-sites/edit-sites.tsx
// module id = 3488
// module chunks = 0